import React from 'react';

import './App.scss';
import Dashboard from './components/Dashboard';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className="App">
       <Dashboard/>
    </div>
  );
}

export default App;
